import React, { Component } from "react"
import {
	// Modal,
	Form,
	Select,
	// Input,
	Button,
	Upload,
	Progress,
} from "antd"
import {
	// getCategories,
	// addQuestion,
	getVideoCategories,
	addVideos,
} from "../services/Api"
import { toast } from "react-toastify"
import { trackPromise } from "react-promise-tracker"

import { connect } from "react-redux"
const { Option } = Select

class MasterFormVideo extends Component {
	constructor(props) {
		super(props)
		this.state = {
			currentStep: 1,
			videoName: "",
			category: "",
			video: {},
			password: "",
			recommendations: [],
			categories: [],
			percentage: 0,
			uploading: "Upload",
		}

		this.dummyRequest = ({ file, onSuccess }) => {
			setTimeout(() => {
				onSuccess("Upload Successful")
			})
		}
		this.normFile = (e) => {
			console.log("Hello")
			console.log("Upload event:", e)
			if (Array.isArray(e)) {
				return e
			}
			if (e.fileList.length > 1) {
				e.fileList.shift()
			}
			return e && e.fileList
		}
		this.uploadVideoTracker = (timeout1,timeout2,clear) => {
			let counter = 250
			console.log("Counter1",counter)
			if (clear !== true) {
				console.log("counting")
				let uploadFunction = () => {
					counter += 250
					timeout1 = setTimeout(uploadFunction, counter)
					console.log("counter23", counter)
					this.setState({
						percentage:
							this.state.percentage >= 90
								? this.state.percentage
								: this.state.percentage + 2,
					})
					if(this.state.percentage === 100){
					clearTimeout(timeout1)
					}
				}

				timeout2 = setTimeout(uploadFunction, counter)
				console.log("counter2", counter)
			} else {
				console.log("not counting")

				clearTimeout(timeout2)
				clearTimeout(timeout1)
				console.log(timeout2)
			}

			this.clearUpload = () => {
			setTimeout(() => {
				this.setState({
					video: {},
					percentage:0,
	
				})
				  this.props.onVideoModalClose()
			}, 4000)
		}
		}



		this.handeUpload = (event) => {
			console.log(event.file.originFileObj)
			this.setState({
				video: event.file.originFileObj,
			})
		}
	}

	handleChange = (event) => {
		const { name, value } = event.target
		this.setState({
			[name]: value,
		})
	}

	handleSelect = (event) => {
		console.log(event)
		this.setState({
			category: event,
		})
	}
	handleSubmit = async (event) => {
		event.preventDefault()
		let timeout1 = null
			let timeout2 = null
			this.uploadVideoTracker(timeout1,timeout2,false)
		const data = {
			user_id: this.props.currentUser._id,
			category_id: this.state.category,
			videoName: this.state.videoName,
			image: this.state.video,
		}

		this.setState({
			uploading: "Uploading",
		})
		trackPromise(
			addVideos(data).then((newVideo) => {
				toast(newVideo.message, { type: "success" })
				this.uploadVideoTracker(timeout1,timeout2,true)
				this.setState({
					videoName: "",
					category: "",
					percentage:100,
					uploading: "Upload",
				})
				this.clearUpload()
			})
		)
		// const newVideo = await addVideos(data)
	}

	_next = async () => {
		let currentStep = this.state.currentStep
		// const email = this.state.email

		currentStep = currentStep >= 2 ? 3 : currentStep + 1
		this.setState({
			currentStep: currentStep,
		})
	}

	_prev = () => {
		let currentStep = this.state.currentStep
		const email = this.state.email
		console.log(email)
		currentStep = currentStep <= 1 ? 1 : currentStep - 1
		this.setState({
			currentStep: currentStep,
		})
	}

	/*
	 * the functions for our button
	 */
	previousButton() {
		let currentStep = this.state.currentStep
		if (currentStep !== 1) {
			return (
				<div className='addQuestion'>
					<button
						className='btn btn-secondary'
						type='button'
						onClick={this._prev}
					>
						Previous
					</button>
				</div>
			)
		}
		return null
	}

	nextButton() {
		let currentStep = this.state.currentStep
		if (currentStep < 3) {
			return (
				<div className='addQuestion'>
					<button
						className='btn btn-primary float-right '
						type='button'
						onClick={this._next}
					>
						Next
					</button>
				</div>
			)
		}
		return null
	}

	submitButton() {
		let currentStep = this.state.currentStep
		if (currentStep > 2) {
			return (
				<div className='addQuestion'>
					<button
						className='btn btn-primary float-right '
						type='button'
						onClick={this.handleSubmit}
					>
						Submit
					</button>
				</div>
			)
		}
		return null
	}

	async componentDidMount() {
		const categories = await getVideoCategories()

		this.setState({
			categories: categories,
		})
	}
	render() {
		return (
			<React.Fragment>
				<h1>
					Add a New Video{" "}
					<span role='img' aria-label='wizard'>
						🧙‍♂️
					</span>
				</h1>
				<p>Step {this.state.currentStep} </p>

				<form onSubmit={this.handleSubmit}>
					{/* 
          render the form steps and pass required props in
        */}
					<Step1
						currentStep={this.state.currentStep}
						handleChange={this.handleChange}
						videoName={this.state.videoName}
					/>
					<Step2
						currentStep={this.state.currentStep}
						handleChange={this.handleSelect}
						data={this.state.categories}
						category={this.state.category}
					/>
					<Step3
						currentStep={this.state.currentStep}
						handleChange={this.handleChange}
						recommendations={this.state.recommendations}
						password={this.state.password}
						normFile={this.normFile}
						customRequest={this.dummyRequest}
						onUpload={this.handeUpload}
						uploading={this.state.uploading}
						percentage={this.state.percentage}
					/>
					<div className='twoButtons'>
						<div className='button1'> {this.previousButton()}</div>
						<div className='button1'> {this.nextButton()}</div>
						<div className='button1'> {this.submitButton()}</div>
					</div>
				</form>
			</React.Fragment>
		)
	}
}

function Step1(props) {
	if (props.currentStep !== 1) {
		return null
	}
	return (
		<div className='form-group'>
			<input
				className='questionSteps'
				id='videoName'
				name='videoName'
				type='text'
				placeholder='Please Describe the Video?'
				value={props.videoName}
				onChange={props.handleChange}
			/>
		</div>
	)
}

function Step2(props) {
	if (props.currentStep !== 2) {
		return null
	}
	return (
		<div className='form-group'>
			<label htmlFor='username'>Select a Category for the Video</label>

			<Select
				showSearch
				style={{ width: "100%" }}
				placeholder='Select the category'
				optionFilterProp='children'
				onSelect={props.handleChange}
				value={props.category}
				filterOption={(input, option) =>
					option.children
						.toLowerCase()
						.indexOf(input.toLowerCase()) >= 0
				}
			>
				{props.data.map((item) => (
					<Option value={item._id}>{item.categoryName}</Option>
				))}
			</Select>
		</div>
	)
}

function Step3(props) {
	if (props.currentStep !== 3) {
		return null
	}

	return (
		<React.Fragment>
			<Progress strokeLinecap='square' percent={props.percentage} />
			<Form.Item>
				<Upload
					name='file'
					onChange={props.onUpload}
					getValueFromEvent={props.normFile}
					customRequest={props.customRequest}
				>
					<Button>{props.uploading} Video</Button>
				</Upload>
			</Form.Item>
		</React.Fragment>
	)
}

function mapStateToProps({ currentUser }) {
	return {
		currentUser: currentUser,
	}
}

export default connect(mapStateToProps)(MasterFormVideo)
